import React, { useEffect, useState } from "react";
import styled from "styled-components";
import images, { bgGraphic } from "../components/img";
import hero from "../images/hero/spidey.jpg";
import phoneicon from "../mobile/icons/icons8_phone.svg";
import mailicon from "../mobile/icons/icons8_email.svg";
import ilustration from "../desktop/Illustrations/Contact-me.svg";
import divider1 from "../desktop/graphic/Desktop-Divider-1.svg";
import divider2 from "../desktop/graphic/Desktop-Divider-2-and-3.svg";
import twitter from "../desktop/icons/icons8_twitter_Outlined.svg";
import github from "../desktop/icons/icons8_github_Outlined.svg";
import linkedin from "../desktop/icons/icons8_linkedin_Outlined.svg";
import swipe from "../desktop/icons/Swipe-Right-Outlined.svg";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

function Home({ about, project, contact, scrollElement }) {
  const { bg1, bg2, bg3, bg4 } = bgGraphic;
  const navigate = useNavigate();
  const [screen, setScreen] = useState();
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  useEffect(() => {
    setScreen(window.innerWidth);
    const width = window.addEventListener("resize", () => {
      setScreen(window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", width);
    };
  }, [screen]);

  return (
    <HomeComponent>
      <section className="hero">
        <div
          data-aos="fade-right"
          data-aos-delay="200"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-once="true"
          className="detail-container"
        >
          <div className="logo">
            <p className="umar">UMAR</p>
            <div className="spidey">SPIDEY</div>
          </div>
          <div className="introduction-section">
            <p className="web-dev">WEB DEVELOPER</p>
            <p className="intro">
              I am a web developer that builds exceptionally responsive websites
              that ensures high conversion and adoption rates.
            </p>
            <div className="btns">
              <button className="hire">HIRE ME</button>
              <button
                onClick={() =>
                  project.current.scrollIntoView({
                    behavior: "smooth",
                  })
                }
                className="work"
              >
                MY WORKS
              </button>
            </div>
          </div>
        </div>
        <div
          data-aos="fade-left"
          data-aos-delay="250"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-easing="ease-in-out"
          className="hero-img-container"
        >
          <img className="hero-img" src={hero} alt="" />
        </div>

        <div className="hero-icons">
          <a
            href="http://github.com/iconicspidey"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={github} alt="" />
          </a>
          <a href="http://" target="_blank" rel="noopener noreferrer">
            <img src={linkedin} alt="" />
          </a>
          <a
            href="http://twitter.com/iconicspidey"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={twitter} alt="" />
          </a>
          <span className="line"></span>
        </div>
        <div className="function">
          <div className="swipe-up">
            <span className="swipe">swipe</span>
            <span className="line"></span>
            <img src={swipe} alt="" />
          </div>
        </div>
        <img src={bg1} alt="" className="bg-1" />
      </section>
      {
        // divider
      }
      <div className="divider-1"></div>
      {
        // didider
      }
      <section ref={about} className="about-container">
        <div data-aos="slide-up" className="header">
          <p className="header-about">ABOUT</p>
          <p className="header-me">ME</p>
        </div>

        <div className="about">
          <div
            data-aos="fade-in"
            data-aos-delay="500"
            data-aos-duration="1000"
            className="about-text"
            data-aos-easing="ease-in-out"
          >
            <p className="p1">
              I am Umar Yahuza, a web developer from Nigeria with a bachelor's
              degree in geography from University of Abuja
            </p>
            <p className="p2">
              I am currently consulting for firms and individuals alike,
              collaborating with brilliant minds to build incredible web
              products
            </p>
          </div>

          <div
            data-aos="fade-in"
            data-aos-delay="500"
            data-aos-duration="1000"
            className="about-skill"
            data-aos-easing="ease-in-out"
          >
            <div className="my-skill">My Skillset</div>
            <div className="skill-container">
              <div className="skill">
                <p className="lang">HTML</p>
                <p className="per"></p>
              </div>
              <div className="skill">
                <p className="lang">CSS</p>
                <p className="per"></p>
              </div>
              <div className="skill">
                <p className="lang">SASS</p>
                <p className="per"></p>
              </div>
              <div className="skill">
                <p className="lang">Javascript</p>
                <p className="per"></p>
              </div>
              <div className="skill">
                <p className="lang">React</p>
                <p className="per"></p>
              </div>
              <div className="skill">
                <p className="lang">Redux</p>
                <p className="per"></p>
              </div>
              <div className="skill">
                <p className="lang">Zustand</p>
                <p className="per"></p>
              </div>
            </div>
          </div>
        </div>
        <img src={bg2} alt="" className="bg-2" />
      </section>
      <div className="divider-2"></div>
      <section ref={project} className="project-section">
        <div
          data-aos="fade-up"
          data-aos-easing="ease-in-out"
          className="header"
        >
          <p className="my">MY</p>
          <p className="projects">Projects</p>
        </div>
        <div className="project-img">
          {images.map((img, i) => {
            return (
              <div
                data-aos={`${
                  screen >= 800
                    ? "zoom-in"
                    : i % 2 == 0
                    ? "fade-right"
                    : "fade-left"
                }`}
                // data-aos-easing="ease-in-out"
                data-aos-delay={`${i + 1}00`}
                data-aos-duration="1000"
                key={img}
                onClick={() => navigate("/project")}
                className="img-container"
              >
                <img className="img" src={img} alt="" />
                <div className="project-title">
                  <p className="title">Project title</p>
                  <p className="date">5th Feb 2022</p>
                </div>
              </div>
            );
          })}
        </div>
        <img src={bg3} alt="" className="bg-3" />
      </section>
      <div className="divider-2"></div>
      <section
        data-aos=""
        data-aos-delay="200"
        data-aos-duration="1000"
        ref={contact}
        className="contact-section"
      >
        <div className="contact-header">
          <p className="contact">CONTACT</p>
          <p className="me">ME</p>
        </div>
        <div className="contact-container">
          <div
            data-aos="zoom-in"
            data-aos-delay="500"
            data-aos-duration="1000"
            className="contact-form"
          >
            <div className="header-container">
              <div className="number">
                <img className="num-icon" src={phoneicon} alt="" />
                <p>+2347064829328</p>
              </div>
              <div className="email">
                <img className="mail-icon" src={mailicon} alt="" />
                <p>yahuzaspidey@gmail.com</p>
              </div>
            </div>
            <form action="">
              <div className="input-container">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" placeholder="John Doe" />
              </div>
              <div className="input-container">
                <label htmlFor="mail">E-mail Address</label>
                <input type="text" id="mail" placeholder="Johndoe@mail.com" />
              </div>
              <div className="input-container">
                <label htmlFor="message">message</label>
                <textarea name="" id="message" aria-disabled></textarea>
              </div>
              <button type="submit">send message</button>
            </form>
          </div>
          <div
            data-aos="zoom-in"
            data-aos-delay="500"
            data-aos-duration="1000"
            className="img-container"
          >
            <img src={ilustration} alt="" className="img" />
          </div>
        </div>
        <img src={bg4} alt="" className="bg-4" />
      </section>
    </HomeComponent>
  );
}

const HomeComponent = styled.div`
  background-color: ${(props) => props.theme.colors.bgcolor};
  /* height: calc(100vh - 100px); */
  /* z-index: -1; */
  /* hero section */
  overflow-x: hidden;
  .hero {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    position: relative;
    @media (min-width: 800px) {
      flex-direction: row;
      height: calc(100vh - 90px);
    }
    .hero-img-container {
      padding: 10px;
      height: 331px;
      width: 267px;
      .hero-img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        border-radius: 20px;
      }
    }
    .detail-container {
      /* logo  */
      .logo {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;

        margin-top: 30px;
        &::before {
          position: absolute;
          color: #82abe1;
          top: -15px;
          content: "{Hello World!}";
          left: 25px;
        }
        &::after {
          position: absolute;
          color: #82abe1;
          top: 2px;
          left: 25px;
          content: "I am";
        }
        .umar {
          font-size: 69px;
          color: ${(props) => props.theme.colors.primarycolor};
          font-weight: 900;
          letter-spacing: 4.14px;
          /* width: 227px;
          height: 96px; */
          /* margin-right: 30px; */
        }
        .spidey {
          font-size: 46px;
          height: 60px;
          /* width: 243.74px; */
          padding: 0 5px;
          /* display: flex;
          justify-content: center;
          align-items: center; */
          font-weight: 800;
          letter-spacing: 7.82px;
          color: ${(props) => props.theme.colors.primarycolor};
          background-color: ${(props) => props.theme.colors.border};
        }
      }
      /* end logo */
      /* introduction sec */
      .introduction-section {
        margin-top: 15px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        gap: 15px;

        .web-dev {
          color: ${(props) => props.theme.colors.secondarycolor};
          font-weight: bold;
          font-size: 25px;
          letter-spacing: 1.4px;
        }
        .intro {
          width: 231px;
          height: 108px;
          color: ${(props) => props.theme.colors.secondarycolor};
          font-size: 14px;
          letter-spacing: 0.56px;
          line-height: 22px;
          font-weight: 600;
          word-spacing: 1.5px;
        }
      }
      /* introduction ended */
      /* btns */
      .btns {
        display: flex;
        justify-content: center;
        gap: 20px;
        align-items: center;
        width: 300px;
        .work,
        .hire {
          border-radius: 4px;
          height: 40px;
          width: 115px;
          font-weight: 700;
        }
        .hire {
          background-color: ${(props) => props.theme.colors.border};
          border: 3px solid ${(props) => props.theme.colors.border};
          color: ${(props) => props.theme.colors.primarycolor};
        }
        .work {
          border: 2px solid ${(props) => props.theme.colors.border};
          background-color: ${(props) => props.theme.colors.bgcolor};
          color: ${(props) => props.theme.colors.secondarycolor};
        }
      }
      /* end btns */
      /* divider */
    }

    .hero-icons {
      position: absolute;
      left: 5%;
      bottom: 0;
      display: none;
      a {
        text-decoration: none;
        img {
          width: 25px;
        }
        img:hover {
          border-radius: 50%;
          background-color: #adb6c4;
        }
      }
      .line {
        height: 100px;
        width: 3px;
        background-color: #82abe1;
        border-radius: 10px;
      }
    }
    .function {
      display: none;
      .swipe-up {
        .swipe {
          color: #82abe1;
        }
        .line {
          height: 100px;
          width: 300px;
          background-color: #82abe1;
          border: 2px solid red;
        }
        img {
          color: #82abe1;
          width: 40px;
        }
      }
    }
    .bg-1 {
      position: absolute;
      display: none;
    }
    @media (min-width: 800px) {
      .hero-icons {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 30px;
      }
      .bg-1 {
        display: block;
      }
    }
    /* end hero */
    /*  */
  }
  .about-container {
    min-height: 90vh;
    padding: 50px 0;
    position: relative;

    /* header */
    .header {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 40px;

      .header-about {
        font-size: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 800;
        letter-spacing: 7px;
        color: ${(props) => props.theme.colors.primarycolor};
      }
      .header-me {
        font-size: 40px;
        height: 50px;
        width: 190px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 800;
        letter-spacing: 5px;
        color: ${(props) => props.theme.colors.primarycolor};
        background-color: ${(props) => props.theme.colors.border};
      }
    }
    /* header end */
    .about {
      display: flex;
      flex-direction: column;
      align-items: center;
      @media (min-width: 800px) {
        display: grid;
        grid-template-columns: repeat(2, auto);
        gap: 100px;
        justify-content: center;
        .about-text {
          position: relative;
          &::before {
            content: "";
            width: 2px;
            height: 250px;
            background-color: #484c56;
            position: absolute;
            top: 0;
            right: -40px;
          }
        }
      }
      .about-text {
        color: ${(props) => props.theme.colors.secondarycolor};
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        width: 290px;
        gap: 20px;
        margin-top: 20px;
        position: relative;
        @media (max-width: 800px) {
          &::after {
            content: "";
            width: 100%;
            height: 2px;
            background-color: #484c56;
            position: absolute;
            bottom: -15px;
          }
        }
        p {
          line-height: 30px;
          font-size: 15px;
          font-weight: 600;
        }
      }
      .about-skill {
        margin-top: 20px;
        padding-top: 10px;
        .my-skill {
          color: #82abe1;
          margin-bottom: 20px;
          font-size: 18px;
          font-weight: 700;
          letter-spacing: 2px;
        }
        .skill-container {
          display: flex;
          flex-direction: column;
          gap: 10px;

          .skill {
            display: flex;
            justify-content: space-between;
            width: 290px;
            align-items: center;

            .lang {
              color: #82abe1;
              font-size: 15px;
              font-weight: 600;
            }
            .per {
              width: 100px;
              height: 4px;
              background-color: #82abe1;
              border-radius: 5px;
            }
          }
        }
      }
    }
    .bg-2 {
      position: absolute;
      width: 100%;
      /* height: 100%; */
      display: none;
      bottom: 0;
    }
    @media (min-width: 800px) {
      .bg-2 {
        display: block;
      }
    }
  }
  /* about ended */

  /* project section */
  .project-section {
    min-height: 100vh;
    /* padding-top: 40px; */
    padding-bottom: 15px;
    position: relative;
    .header {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 40px;
      .my {
        color: ${(props) => props.theme.colors.primarycolor};
        font-size: 46px;
        font-weight: 800;
        letter-spacing: 5px;
      }
      .projects {
        color: ${(props) => props.theme.colors.primarycolor};
        background-color: ${(props) => props.theme.colors.border};
        font-size: 46px;
        padding: 1px 4px;
        /* display: flex;
        justify-content: center;
        align-items: center; */
        font-weight: 800;
        letter-spacing: 3px;
      }
    }
    .project-img {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      @media (min-width: 800px) {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(260px, 260px));
        justify-content: center;
        justify-items: center;
        gap: 30px;
        padding: 0 10%;
      }
      gap: 15px;
      .img-container {
        width: 260px;
        border-radius: 7px;
        border: 2px solid #82abe1;
        background-color: ${(props) => props.theme.colors.border};

        .img {
          border-top-right-radius: inherit;
          border-top-left-radius: inherit;
          width: 100%;
          height: 110px;
          object-fit: cover;
        }
        .project-title {
          width: 100%;
          background-color: ${(props) => props.theme.colors.border};
          display: flex;
          justify-content: space-around;
          height: 50px;
          align-items: center;
          .title {
            color: ${(props) => props.theme.colors.primarycolor};
            font-size: 20px;
            font-weight: 700;
          }
          .date {
            color: #c1d6f0;
            margin-left: 15px;
            margin-bottom: 5px;
            font-size: 11px;
            align-self: flex-end;
            font-weight: 600;
          }
        }
      }
    }
    .bg-3 {
      position: absolute;
      top: 0;
      width: 100%;
      display: none;
    }
    @media (min-width: 800px) {
      .bg-3 {
        display: block;
      }
    }
  }
  /* project section ended */

  /* contact section  */
  .contact-section {
    position: relative;
    .contact-header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      .contact {
        color: ${(props) => props.theme.colors.primarycolor};
        font-size: 30px;
        font-weight: 800;
      }
      .me {
        color: ${(props) => props.theme.colors.primarycolor};
        background-color: ${(props) => props.theme.colors.border};
        font-size: 30px;
        height: 43px;
        width: 170px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 800;
      }
    }
    .contact-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 75vh;

      .img-container {
        width: 700px;
        height: 400px;
        display: none;

        .img {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }
      .contact-form {
        width: 333px;
        margin-top: 20px;
        .header-container {
          display: flex;
          justify-content: space-between;
          padding: 0 10px;
          margin-bottom: 20px;
          .number {
            text-align: center;
            .num-icon {
              width: 18px;
              height: 18px;
            }
            p {
              font-size: 12px;
              color: ${(props) => props.theme.colors.secondarycolor};
              border-bottom: 2px solid ${(props) => props.theme.colors.line};
              padding-bottom: 2px;
            }
          }
          .email {
            text-align: center;
            .mail-icon {
              width: 18px;
              height: 18px;
            }
            p {
              font-size: 12px;
              font-weight: 400;
              color: ${(props) => props.theme.colors.secondarycolor};
              border-bottom: 2px solid ${(props) => props.theme.colors.line};
              padding-bottom: 2px;
            }
          }
        }
        form {
          display: flex;
          flex-direction: column;
          gap: 20px;
          align-items: flex-end;
          .input-container {
            display: flex;
            flex-direction: column;
            width: 100%;
            input {
              height: 40px;
              border-radius: 5px;
              font-weight: 500;
              border: 2.8px solid
                ${(props) => props.theme.colors.secondarycolor};
              text-indent: 10px;
              color: #adb6c4;
              background-color: ${(props) => props.theme.colors.bgcolor};
              &::placeholder {
                color: #adb6c4;
              }
            }
            label {
              color: ${(props) => props.theme.colors.secondarycolor};
              font-size: 12px;
              font-weight: 600;
              margin-bottom: 3px;
            }
            textarea {
              color: #adb6c4;
              background-color: ${(props) => props.theme.colors.bgcolor};
              border: 2.8px solid
                ${(props) => props.theme.colors.secondarycolor};
              border-radius: 5px;
              height: 100px;
              resize: none;
            }
          }
          button {
            width: 120px;
            height: 40px;
            background-color: ${(props) => props.theme.colors.border};
            font-weight: 600;
            border: none;
            color: ${(props) => props.theme.colors.primarycolor};
            border-radius: 5px;
          }
        }
      }
    }
    @media (min-width: 800px) {
      .contact-container {
        justify-content: space-between;
        gap: 20px;
        .img-container {
          display: block;
        }
      }
      .contact-form {
        margin-left: 10%;
      }
    }

    .bg-4 {
      position: absolute;
      display: none;
      width: 100%;
      top: 0;
    }
    @media (min-width: 800px) {
      .bg-4 {
        display: block;
      }
    }
  }
  /* screen divider styles */
  .divider-1 {
    background-image: url(${() => divider1});
    height: 40px;
  }
  .divider-2 {
    background-image: url(${() => divider2});
    height: 40px;
  }
`;

export default Home;
